export default "__VITE_ASSET__b00d8c17__"